import { gql } from '@apollo/client';
import ErrorResultFragment from "../../fragments/ErrorResult";
import CompanyInvoiceInformationCardFragment from "../../fragments/SalesDocuments/companyInvoiceInformationCardFragment";

const UPDATE_CREATE_COMPANY_INVOICE_INFORMATION_CARD = gql`mutation createUpdateInvoiceCard($input: CompanyInvoiceInformationCardInput) {
	companyAdminContext {
		salesDocuments {
			createUpdateCompanyCard(				
				input: $input
			) {
				success
				errorResult
				{
					...ErrorResultFields
				}
				card {
					...CompanyInvoiceInformationCardFragment
				}
			}
		}
	}
}

${CompanyInvoiceInformationCardFragment}
${ErrorResultFragment}
`;

export default UPDATE_CREATE_COMPANY_INVOICE_INFORMATION_CARD;